import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Login extends Component {

  render() {
    return (
      <section className="Login w-100 pa2 bg-moon-gray flex flex-column items-center">
				{this.props.user ?
					<article className="flex flex-column items-center bg-white card w-100 w-75-m w-50-l mt3">
						<div className="droid f3 black mv5 tc">Welcome</div>
						<Link to="/admin" className="link pathway card pointer bg-animate dim bg-gray ph4 pv3 f3 f2-ns tc near-white mb5">/ADMIN</Link>
						<div onClick={this.props.logout} className="link pathway card pointer bg-animate dim bg-gray ph4 pv3 f3 f2-ns tc near-white mb5">LOG OUT</div>
					</article>
					:
					<article className="flex flex-column items-center bg-white card w-100 w-75-m w-50-l mt3">
						<div className="droid f3 black mv5 tc">Please log in to continue</div>
						<div onClick={this.props.login} className="link pathway card pointer bg-animate dim bg-gray ph4 pv3 f3 f2-ns tc near-white mb5">LOG IN</div>
					</article>
				}
      </section>
    )
  }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/admin/Login.js